import { defineStore } from "pinia";
import { ref } from "vue";

export const useSelectedRowsStore = defineStore("selectedRows", () => {
    const tasks = ref({
        selectedRows: {},
        selectAllValue: false,
    });

    const files = ref({
        selectedRows: {},
        selectAllValue: false,
    });

    const assets = ref({
        selectedRows: {},
        selectAllValue: false,
    });

    return {
        tasks,
        files,
        assets,
    };
});
